export function SectionHeader({ C, eyebrow, title, subtitle }) {
  return (
    <div style={{ textAlign: "center", maxWidth: 560, margin: "0 auto" }}>
      {eyebrow && (
        <div style={{
          color: C.primary, fontWeight: 800, fontSize: 12,
          letterSpacing: "0.08em", textTransform: "uppercase", marginBottom: 10,
        }}>{eyebrow}</div>
      )}
      <h2 style={{ color: C.text, fontWeight: 900, fontSize: 28, letterSpacing: "-0.02em", margin: "0 0 10px" }}>
        {title}
      </h2>
      {subtitle && <p style={{ color: C.muted, fontSize: 14.5, lineHeight: 1.6, margin: 0 }}>{subtitle}</p>}
    </div>
  );
}
